import { render } from "./OutsourceHREng.vue?vue&type=template&id=33df36a0&scoped=true&lang=html"
import script from "./OutsourceHREng.vue?vue&type=script&lang=js"
export * from "./OutsourceHREng.vue?vue&type=script&lang=js"

import "./OutsourceHREng.vue?vue&type=style&index=0&id=33df36a0&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-33df36a0"

export default script